import { cva } from 'class-variance-authority';

const menuBaseStyles = ['absolute', 'm-0', 'p-0', 'shadow-md', 'border'];

const menuStylesSAG = cva([...menuBaseStyles, 'rounded-md', 'bg-[#F3F3F0]', 'dark:bg-[#23233C]']);

const menuStylesSHS = cva([...menuBaseStyles, 'rounded-md', 'bg-white', 'dark:bg-[#1a1a1a]', 'border-[#333333]']);

export { menuStylesSAG, menuStylesSHS };
